import { useQuery } from '@apollo/client';

import type {
  GetVitaJobRoleSuggestionsQuery,
  GetVitaJobRoleSuggestionsQueryVariables,
} from '@xing-com/crate-lebenslauf-graphql';
import { GetVitaJobRoleSuggestionsDocument } from '@xing-com/crate-lebenslauf-graphql';

type JobRoleSuggestions = {
  data?: GetVitaJobRoleSuggestionsQuery;
  refetch: (value: string) => void;
};

export const useJobRoleSuggestions = (value: string): JobRoleSuggestions => {
  const getQueryVariables = (
    text: string
  ): GetVitaJobRoleSuggestionsQueryVariables => ({
    text,
    consumer: 'loggedout.web.lebenslauf.jobrole',
  });
  const { data, refetch: refetchSuggestions } = useQuery(
    GetVitaJobRoleSuggestionsDocument,
    {
      variables: getQueryVariables(value || ''),
      skip: !value,
      ssr: false,
    }
  );
  const refetch = (value: string): void => {
    refetchSuggestions(getQueryVariables(value));
  };

  return { data, refetch };
};
